import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'

import { userManager } from '@/shared/auth/oidc'

export const Route = createFileRoute('/auth/callback')({
  component: Callback,
})

function Callback() {
  const navigate = useNavigate()
  const { t } = useTranslation()
  // O `code` do OAuth é de USO ÚNICO e o StrictMode roda effects 2x: sem esta
  // guarda, a 2ª troca falha com invalid_grant e o login "pisca e volta".
  const jaRodou = useRef(false)

  useEffect(() => {
    if (jaRodou.current) return
    jaRodou.current = true

    void (async () => {
      try {
        const user = await userManager.signinCallback()
        const state = user?.state as { returnTo?: string } | undefined
        const returnTo = state?.returnTo
        // `returnTo` é uma URL JÁ MONTADA (pathname + query), capturada de
        // `location.href` na guarda _authed — ex.: "/contatos/funcionarios?
        // pagina=1&linhas=50&ordenar=name". Com `to:` o router trata a string
        // INTEIRA como template de rota: casa só o pathname e RECONCATENA a
        // search canônica, gerando "?...?..." (query duplicada). Isso quebra o
        // validateSearch (`ordenar=name?pagina=...` não é opção do enum) e
        // derruba a página no PRIMEIRO login em qualquer deep link com filtros.
        // `href:` navega para a URL pronta, parseando a query uma única vez.
        if (returnTo !== undefined && returnTo !== '') {
          await navigate({ href: returnTo, replace: true })
        } else {
          await navigate({ to: '/', replace: true })
        }
      } catch {
        await navigate({ to: '/auth/login', replace: true })
      }
    })()
  }, [navigate])

  return (
    <div className="bg-canvas text-ink-muted grid min-h-dvh place-items-center text-sm">
      <p role="status">{t('states.loading')}</p>
    </div>
  )
}
